import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import request from "../../../utils/request";
import { useQueryClient } from "@tanstack/react-query";
import { MdCandlestickChart } from "react-icons/md";

function UpdateMofaModal({ isOpen, onClose }) {
  const queryClient = useQueryClient();

  const [registrationNo, setRegistrationNo] = useState("");
  const [mofaNo, setMofaNo] = useState("");
  const [mofaUpdateDate, setMofaUpdateDate] = useState("");

  const handleSubmit = async () => {
    try {
      if (!registrationNo || !mofaNo) {
        toast.error("Please fill all fields");
        return;
      }
      const data = {
        registrationNo,
        mofaNo,
        mofaUpdateDate,
      };
      const res = await request.updateOne("users/update/mofa", "", data);
      if (res.status === "OK") {
        queryClient.invalidateQueries(["users"]);
      } else {
        toast.error(res.data?.data?.error || "Failed to update MOFA");
      }

      onClose();
      //response
      setRegistrationNo("");
      setMofaNo("");
      setMofaUpdateDate("");
    } catch (error) {
      toast.error(
        error?.response?.data?.data?.error || "Failed to update MOFA",
      );
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Update MOFA Number</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Registration Number</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Registration No"
              value={registrationNo}
              onChange={(e) => setRegistrationNo(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>MOFA Number</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter MOFA No"
              value={mofaNo}
              onChange={(e) => setMofaNo(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>MOFA Update Date</Form.Label>
            <Form.Control
              type="date"
              placeholder="Enter MOFA Update Date"
              value={mofaUpdateDate}
              onChange={(e) => setMofaUpdateDate(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Update MOFA
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default UpdateMofaModal;
